import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2.64 18.48h10.08l5.76 4.32v-4.32h2.88a1.44 1.44 0 001.44-1.44V2.64a1.44 1.44 0 00-1.44-1.44H2.64A1.44 1.44 0 001.2 2.64v14.4a1.44 1.44 0 001.44 1.44zM18.479 7.68H5.518M18.479 12H8.399",
      stroke: "#333",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export {
  o as default
};
